export const PASSWORD_RULES = [
  'Length must be at least 12 characters.',
  'Password must contain numbers.',
  'Password must contain uppercase letters.',
  'Password must contain lowercase letters.',
  'Password must have at least one special symbol (such as @#$).',
];
